import { ProductFormBody } from './ProductFormBody'

export default ProductFormBody
